export const formattedDeliveryInfo = {
  methods: {
    formatDeliverySpotsInfo (spotsInfo, slug, isThankYouPage) {
      const formattedDeliveryInfo = []

      if (slug === 'pickupDPDInternational') {
        spotsInfo.forEach(spot => {
          const {
            ref,
            address,
            latitude,
            longitude,
            isActive,
            schedule,
            total_max_weight
          } = spot

          const formattedSpot = {
            description: address,
            isActive,
            latitude,
            longitude,
            schedule,
            maxWeight: total_max_weight,
            uid: ref
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else if (slug === 'novaPoshtaWarehouse') {
        spotsInfo.forEach(spot => {
          const {
            ref,
            post_office_number: officeNumber,
            description: address,
            latitude,
            longitude,
            isActive,
            schedule,
            total_max_weight: maxWeight,
            is_available: isAvailable
          } = spot

          const formattedSpot = {
            description: address,
            isActive,
            latitude,
            longitude,
            schedule,
            maxWeight,
            officeNumber,
            isAvailable,
            uid: ref
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else if (slug === 'pickup' || slug === 'pickupInternational') {
        spotsInfo.forEach(spot => {
          const { address, coordinates, working_hours: workingHours, phone, uid, cart_status: cartStatus, store_type: type, id } = spot

          const formattedSpot = {
            description: address,
            latitude: coordinates[0],
            longitude: coordinates[1],
            schedule: workingHours ? workingHours.replace(/, /gi, '<br/>') : '',
            phone,
            uid,
            cartStatus,
            status: cartStatus,
            type,
            id
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else if (slug === 'availability') {
        spotsInfo.forEach(spot => {
          const { store_uid: storeUid, store_id: storeId, quantity, status, static_map_link: staticMapLink, is_in_wait_list: isInWaitList } = spot
          const { address, coordinates, working_hours: workingHours, phone, google_link: googleLink } = spot.store_data

          const formattedSpot = {
            description: address,
            title: address,
            latitude: +coordinates[0],
            longitude: +coordinates[1],
            schedule: workingHours ? workingHours.replace(/, /gi, '<br/>') : '',
            phone,
            storeUid,
            storeId,
            quantity,
            status,
            googleLink,
            staticMapLink,
            isInWaitList
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else if (slug === 'chooseStore') {
        spotsInfo.forEach(spot => {
          const { address, coordinates, working_hours: workingHours, phone, uid: storeUid, id: storeId, quantity } = spot

          const formattedSpot = {
            description: address,
            title: address,
            latitude: +coordinates[0],
            longitude: +coordinates[1],
            schedule: workingHours ? workingHours.replace(/, /gi, '<br/>') : '',
            phone,
            storeUid,
            storeId,
            quantity
            // status,
            // googleLink,
            // staticMapLink,
            // isInWaitList
          }

          formattedDeliveryInfo.push(formattedSpot)
        })
      } else {
        spotsInfo.forEach(spot => {
          const { address, latitude, longitude, phone, index } = spot

          const formattedSpot = { description: address, latitude, longitude, phone, uid: index }
          formattedDeliveryInfo.push(formattedSpot)
        })
      }

      if (isThankYouPage) formattedDeliveryInfo[0].isSuccessful = true

      return formattedDeliveryInfo
    }
  }
}
